import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Window from "../2/Controls/Window";
import AddEditOffer from "../Catalogue/AddEditOffer";

class CouponList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      allCoupons: [],   // master data
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      searchParam: "",

      showAddCoupon: false,
      showFilter: false,
      showDelete: false,

      selectedRow: null,

      isFilterActive: false,

      listPageSettings: {

        Title: "Coupons",

        Search: {

          showSearch: true,
          placeholder: "Search by coupon name",

          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,

          hideFilter: true,
        },

        HeaderButtons: [

          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },

        ],

        Columns: [

          {
            Name: "Name",
            Type: "multiple",
            Columns: [
              { Column: "Name" },
              { Column: "Description" }
            ],
          },

          {
            Name: "Details",
            Type: "multiple",
            Columns: [
              { Column: "ValidityFrom", Label: "Validity From", Type: "date" },
              { Column: "ValidityTo", Label: "Validity To", Type: "date" },
            ],
          },

          {
            Name: "Description",
            Type: "multiple",
            Columns: [
              { Column: "OfferType", Label: "Offer Type" },
              { Column: "PurchaseGroup", Label: "Purchase Group" },
              { Column: "PurchaseQty", Label: "Purchase Qty" },
              { Column: "FreeGroup", Label: "Free Group" },
              { Column: "FreeQty", Label: "Free Qty" },
            ],
          },

          {
            Name: "",
            Type: "multiple",
            ShowInMobile: true,
            Columns: [
              { Column: "Name", CSS: "main" },
              { Column: "OfferType", Label: "Offer Type" },
            ],
          },

        ],

        RowButtons: [

          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit"
          },

          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete"
          }

        ]

      }

    };

  }

  componentDidMount() {

    this.getInitialData();

  }

  // =====================
  // GET DATA (API CALL ONLY ONCE)
  // =====================

  getInitialData = async () => {

    this.setState({ loading: true });

    try {

      const offers = await this.props.getOffers();

      const data = offers.filter(
        (m) =>
          m &&
          m.hasOwnProperty("Type") &&
          m.Type === "Coupon" &&
          !m.IsDeleted
      );

      this.setState(
        {
          allCoupons: data
        },
        this.applyFilterPagination
      );

    }

    catch (error) {

      console.error(error);

      this.setState({
        loading: false
      });

    }

  };

  // =====================
  // FILTER + PAGINATION (FRONTEND)
  // =====================

  applyFilterPagination = () => {

    let data = [...this.state.allCoupons];

    // SEARCH FILTER
    if (this.state.searchParam) {

      const searchText =
        this.state.searchParam.toLowerCase();

      data = data.filter((item) =>

        (item.Name &&
          item.Name.toLowerCase().includes(searchText))

        ||

        (item.Description &&
          item.Description.toLowerCase().includes(searchText))

        ||

        (item.OfferType &&
          item.OfferType.toLowerCase().includes(searchText))

        ||

        (item.PurchaseGroup &&
          item.PurchaseGroup.toLowerCase().includes(searchText))

        ||

        (item.FreeGroup &&
          item.FreeGroup.toLowerCase().includes(searchText))

        ||

        (item.CouponCode &&
          String(item.CouponCode).toLowerCase().includes(searchText))

      );

    }

    // PAGINATION
    const startIndex =
      (this.state.page - 1) *
      this.state.pageSize;

    const paginatedData =
      data.slice(
        startIndex,
        startIndex + this.state.pageSize
      );

    this.setState({

      list: paginatedData,
      totalCount: data.length,
      loading: false

    });

  };

  // =====================
  // SEARCH
  // =====================

  onSearch = (text) => {

    this.setState(

      {
        searchParam: text,
        page: 1
      },

      this.applyFilterPagination

    );

  };

  onRefreshClick = () => {

    this.setState(

      {
        searchParam: "",
        page: 1
      },

      this.applyFilterPagination

    );

  };

  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount /
      this.state.pageSize
    );

    if (this.state.page < totalPages) {

      this.setState(

        {
          page: this.state.page + 1
        },

        this.applyFilterPagination

      );

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState(

        {
          page: this.state.page - 1
        },

        this.applyFilterPagination

      );

    }

  };

  onFirstClick = () => {

    this.setState(

      {
        page: 1
      },

      this.applyFilterPagination

    );

  };

  onLastClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount /
      this.state.pageSize
    );

    this.setState(

      {
        page: totalPages
      },

      this.applyFilterPagination

    );

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState(

      {
        pageSize: Number(size),
        page: 1
      },

      this.applyFilterPagination

    );

  };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.setState({

        showAddCoupon: true,
        selectedRow: null

      });

    }

  };

  // =====================
  // ROW BUTTONS
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.setState({

        showAddCoupon: true,
        selectedRow: row

      });

    }

    if (btn.Type === "delete") {

      this.setState({

        showDelete: true,
        selectedRow: row

      });

    }

  };

  // =====================
  // DELETE
  // =====================

  deleteRecord = async () => {
    
   this.setState(

      {

        showDelete: false,
        loading:true

      },


    );
    await this.props.deleteOffer(
      this.state.selectedRow.key
    );

    this.setState(

      {

        loading: false,
        selectedRow: null

      },

      this.getInitialData

    );

  };

  // =====================
  // POPUP EVENTS
  // =====================

  onPostPopupSave = () => {

    this.setState(

      {

        showAddCoupon: false,
        selectedRow: null

      },

      this.getInitialData

    );

  };

  onClosePopup = () => {

    this.setState({

      showAddCoupon: false,
      selectedRow: null

    });

  };

  // =====================
  // RENDER
  // =====================
  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    return (

      <>

        <ListingPage
         onPageChange={this.onPageChange}

          {...this.props}

          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state.listPageSettings.Search,

              isFilterActive:
                this.state.searchParam !== ""

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={
            this.state.totalCount
          }

          recordFrom={
            (this.state.page - 1) *
            this.state.pageSize
          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={
            this.onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={
            this.onHeaderButtonClicked
          }

          onRowButtonClicked={
            this.onRowButtonClicked
          }

        />

        {/* DELETE CONFIRM */}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(btn) => {

              if (btn === "Yes")

                this.deleteRecord();

              else

                this.setState({
                  showDelete: false
                });

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }
            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

        {/* ADD / EDIT */}

        {this.state.showAddCoupon && (

          <AddEditOffer

            {...this.props}

            selectedRecord={
              this.state.selectedRow
            }

            type="coupons"

            onSave={this.onPostPopupSave}

            onClose={this.onClosePopup}

          />

        )}

      </>

    );

  }

}

export default CouponList;